import { Professional } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { formatSpecialties } from '@/utils/professional/professional-license.util';

interface ProfessionalSpecialtiesAndLicenseProps {
  professional: Professional;
}

function formatLicense(professional: Professional): string | undefined {
  const [license] = professional.licenses ?? [];

  if (!license) {
    return;
  }

  return `${license.certificationBodyInitials}/${license.licenseState} - ${license.licenseRecord}`;
}

export function ProfessionalSpecialtiesAndLicense({ professional }: ProfessionalSpecialtiesAndLicenseProps) {
  return (
    <ol className="flex flex-col items-center md:items-start">
      {formatSpecialties(professional).map((specialty) => (
        <li className="text-gray-700 text-sm text-center md:text-start" key={specialty}>
          {specialty}
        </li>
      ))}

      <li className="text-gray-700 text-sm">
        <span className="flex items-center gap-1" data-testid={DataTestIdEnum.PROFESSIONAL_LICENSE_HEADER}>
          {formatLicense(professional)}
        </span>
      </li>
    </ol>
  );
}
